<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('uomCategory.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('uomCategory.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="row">
          <div class="col-sm-4">
            <ts-button
              color="info"
              outline
              @click="$router.push({ name: 'uom-category-create' })"
            >
              {{ $t('add_new') }}
            </ts-button>
          </div>
          <div class="col-sm-8 d-flex justify-content-end">
            <ts-input
              v-model="search"
              placeholder="Search"
              style="width: 300px;"
            />
          </div>
        </div>
      </ts-card-wrapper>
      <Table
          :columns="columns"
          :data="resources"
          size="small"
          :loading="loading"
          highlight-row
          stripe
          max-height="700"
        > 
          <template slot-scope="{ row }" slot="nameKh">
            <td class="kh-font" style="border-bottom: none;">{{ row.uom_cat_name_kh }}</td>
          </template>
          <template slot-scope="{ row }" slot="action">
            <a
              href="#"
              v-tooltip="'Edit'"
              class="mr-2 text-primary"
              @click.prevent="edit(row)"
            >
              <i class="fas fa-edit"></i>
            </a>
            <a-popconfirm
              placement="leftTop"
              :title="$t('are_you_sure_to_delete')"
              :ok-text="$t('yes')"
              :cancel-text="$t('no')"
              @confirm="destroy(row)"
            >
              <a href="#" :disabled="row._deleting">
                <i class="fas fa-circle-notch spin" v-if="row._deleting"></i>
                <i class="fa fa-trash text-red" v-else></i>
              </a>
            </a-popconfirm>
          </template>
      </Table>
      <div class="d-flex justify-content-between align-items-center p-15">
        <ts-total-list v-model="pagination" />
        <ts-pagination v-model="pagination" @navigate="fetchData">
        </ts-pagination>
      </div>
    </ts-card>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'
export default {
  name: 'uomCategory',
  data() {
    return {
      loading: false,
    }
  },
  computed: {
    ...mapState('product/uomCategory', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.product.uomCategory.search
      },
      set(newValue) {
        this.$store.commit('product/uomCategory/SET_SEARCH', newValue)
        this.$store.commit('product/uomCategory/RESET_CURRENT_PAGE')
      }
    },
    columns() {
      return [
        { 
          title: this.$t('uomCategory.nameKh'),
          slot: 'nameKh'
        },
        { 
          title: this.$t('uomCategory.nameEn'),
          key: 'uom_cat_name_en'
        },
        {
          title: this.$t('actions'),
          key: 'action',
          slot: 'action',
          fixed: 'right',
          align: 'center',
          width: 94
        }
      ]
    }
  },
  methods: {
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('product/uomCategory/fetch', attributes)
        .then(response => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    edit(record) {
      this.$store.commit('product/uomCategory/SET_EDIT_DATA', record)
      this.$router.push({
        name: 'uom-category-edit',
        params: { id: record.uom_cat_id }
      })
    },
    destroy(record) {
        record._deleting = true
        this.$store
          .dispatch('product/uomCategory/destroy', record.uom_cat_id)
          .then(response => {
            this.fetchData()
            this.$toasted.success(response.message)
            record._deleting = false
          })
          .catch(error => {
            this.$toasted.error(error.message)
            record._deleting = false
          })
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData()
    }, 500)
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('product/uomCategory/RESET_STATE')
    next()
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.fetchData()
    })
  }
}
</script>
